import ViewPreviousHistoryModal from './ViewPreviousHistoryModal'
import ANTDButton from '../../../shared/antd/ANTDButton'
import { ANTDDatePicker } from '../../../shared/antd/ANTDDatePicker'
import Label from '../../../shared/Label'
import { SAVE_FORMAT } from '../../../utils/dayjs'
import bankPaymentReport from '../container/bankPaymentReport.container'

const BankPaymentReport = () => {
  const {
    t,
    loading,
    selectedDate,
    viewPreviousHistory,
    onDateChange,
    onGenerateBankPaymentReport,
    onViewPreviousHistory,
    onViewHistoryModelClose,
  } = bankPaymentReport()

  return (
    <>
      <div
        style={{
          borderRadius: '10px',
          padding: '15px 10px',
          marginTop: '10px',
        }}
      >
        <div className="d-flex align-end flex-wrap flex-end">
          <div>
            <Label text={t('rpt_DateFilter')} />
            <ANTDDatePicker
              className="w-100 mt-5"
              allowClear={false}
              format={SAVE_FORMAT}
              value={selectedDate}
              onChange={onDateChange}
            />
          </div>
          <ANTDButton
            type="primary"
            className="ml-10 mt-10"
            loading={loading}
            onClick={onGenerateBankPaymentReport}
          >
            {t('btn_GenerateBankPaymentReport')}
          </ANTDButton>
          <ANTDButton
            type="primary"
            className="ml-10 mt-10"
            onClick={onViewPreviousHistory}
          >
            {t('btn_ViewPreviousHistory')}
          </ANTDButton>
        </div>
      </div>

      {viewPreviousHistory.open && (
        <ViewPreviousHistoryModal
          open={viewPreviousHistory.open}
          onClose={onViewHistoryModelClose}
          payload={{
            sheetType: viewPreviousHistory.sheetType,
          }}
        />
      )}
    </>
  )
}

export default BankPaymentReport
